/**
 * Creates a Ping instance.
 * @returns {Ping}
 * @constructor
 */
var Ping = function (opt) {
  this.opt = opt || {};
  this.timeout = this.opt.timeout || 0;
  this.logError = this.opt.logError || false;
};

/**
 * Pings source and triggers a callback when completed.
 * @param {string} source Source of the website or server, including protocol and port.
 * @param {Function} callback Callback function to trigger when completed. Returns error and ping value.
 * @returns {Promise|undefined} A promise that both resolves and rejects to the ping value. Or undefined if the browser does not support Promise.
 */
Ping.prototype.ping = function (source, callback) {
  var self = this;
  self.wasSuccess = false;
  self.img = new Image();
  self.img.onload = onload;
  self.img.onerror = onerror;

  var timer;
  var start = performance.now();

  function onload(e) {
    self.wasSuccess = true;
    pingCheck.call(self, e);
  }

  function onerror(e) {
    //self.wasSuccess = false;
    self.wasSuccess = true;
    pingCheck.call(self, e);
  }

  if (self.timeout) {
    timer = setTimeout(function () {
      pingCheck.call(self, undefined);
    }, self.timeout);
  }

  /**
   * Times ping and triggers callback.
   */
  function pingCheck() {
    if (timer) {
      clearTimeout(timer);
    }

    var pong = Math.round(performance.now() - start);

    if (!this.wasSuccess) {
      if (self.logError) {
        console.error("error loading resource");
      }

      return callback("error", pong);
    }

    return callback(null, pong);
  }

  self.img.src = source;
};

if (typeof exports !== "undefined") {
  if (typeof module !== "undefined" && module.exports) {
    module.exports = Ping;
  }
} else {
  window.Ping = Ping;
}

// ES module export for Vite
export default Ping;
